import z from "zod";

const langchainErrorTypeValues = ["TOOL_NOT_FOUND", "TOOL_INVOCATION_FAILED", "MISSING_FILENAME_PARAMETER"] as const;

const langchainErrorTypeSchema = z.enum(langchainErrorTypeValues);
const LangchainErrorType = langchainErrorTypeSchema.enum;
type LangchainErrorType = z.infer<typeof langchainErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type LangchainErrors =
  | {
      errorType: typeof LangchainErrorType.TOOL_NOT_FOUND;
      data: {
        toolName: string;
      };
    }
  | {
      errorType: typeof LangchainErrorType.TOOL_INVOCATION_FAILED;
      data: {
        errors: unknown[];
      };
    }
  | {
      errorType: typeof LangchainErrorType.MISSING_FILENAME_PARAMETER;
      data: undefined;
    };

export const langchainErrorDetails: Record<LangchainErrorType, ErrorDetails> = {
  [LangchainErrorType.TOOL_NOT_FOUND]: {
    sentryDescription: "Tool not found in available tools",
  },
  [LangchainErrorType.TOOL_INVOCATION_FAILED]: {
    sentryDescription: "Tool invocation failed with errors",
  },
  [LangchainErrorType.MISSING_FILENAME_PARAMETER]: {
    sentryDescription: "Missing filename parameter for dataset operation",
  },
};
